import { useMutation } from '@tanstack/react-query';

import { ExternalApiService } from '../../../services';
import { type IDPECMConfigPayload } from '../../../services/types';

class ApiError extends Error {
  status: string | number;

  idProofingUrl: string;

  errorMessage: string;

  constructor(
    message: string,
    idProofingUrl: string,
    status: number,
    errorMessage: string
  ) {
    super(message);
    this.name = 'ApiError';
    this.idProofingUrl = idProofingUrl;
    this.status = status;
    this.errorMessage = errorMessage;
    Object.setPrototypeOf(this, ApiError.prototype); // Ensure proper inheritance
  }
}
interface ApiResponse {
  /** Indicates if the API call was successful */
  success: boolean;
  /** Optional message from the server */
  errorMessage: string;
  status: number;
  error: ApiError;
  ok?: boolean;
}

const putConfig = async (payload: IDPECMConfigPayload) => {
  const response = (await ExternalApiService.putECMConfig(
    payload
  )) as ApiResponse;

  return response;
};

const useUpdateConfig = () =>
  useMutation({
    mutationFn: (payload: IDPECMConfigPayload) => putConfig(payload),
  });

export default useUpdateConfig;
